/*
  Generic Player states based in Tizen implementation.
 */
export default {
  NONE: "NONE",
  IDLE: "IDLE",
  READY: "READY",
  PLAYING: "PLAYING",
  PAUSED: "PAUSED",
  SUBS_READY: "SUBS_READY"
};
